import { environment } from 'environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient,  HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EntityAccess, SalesPersonCustomerAddressDTO } from '../models/entity-access-model';
import { EntityRequest } from 'app/core/cnc/admin/models/entity-request-model';
import { List } from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class EntitiesAccessService {

  private API_VALIDATE_ENTITY_URL = environment.ipserver + 'AnA-backend/private/entity/validatePermission';

  private API_USER_ENTITIES_URL = environment.ipserver + 'AnA-backend/private/entity/getEntitiesByUser';

  private API_USER_ENTITIES_BY_ENTITY_URL = environment.ipserver + 'AnA-backend/private/entity/getEntitiesByEntityType';

  private API_salespersonAddressCodes_URL = environment.ipserver + 'AnA-backend/private/entity/updateCustomerAddressesEntity';
  constructor(private http: HttpClient) { }



  /**
     * Method that checks if user has access to entity 
     * @author Rosa Korse
     * @since 2020-04-08
     * @return Observable with a json that returns a boolean
     */
     public validateUserEntity(entityAccess: EntityAccess): Observable<boolean> {
      const paramsForReq = new HttpParams()
          .set('entityType', entityAccess.entityType)
          .set('entity', entityAccess.entity);

      return this.http.get<boolean>(this.API_VALIDATE_ENTITY_URL, { params: paramsForReq });
  }

  
   /**
   * Method that obtains a list of user's entities based on Application/entity type 
   * @author Rosa Korse
   * @since 2020-04-14
   * @return Observable with a json that contains a list of entities
   */
    public getAllEntitiesByUser(entityType: string): Observable<string[]> {
      const paramsForReq = new HttpParams()
          .set('entityType', entityType);
      return this.http.get<string []>(this.API_USER_ENTITIES_URL, { params: paramsForReq });
  }

  /**
    * Method that sends a post request to the API with an EntityRequest object in the body
    * @param entityRequest The EntityRequest object to be sent in the request body
    * @returns Observable with a json that contains a list of entities
    */
    public getAllUsersByEntity(entityRequest: EntityRequest): Observable<string[]> {
     return this.http.post<any>(this.API_USER_ENTITIES_BY_ENTITY_URL, entityRequest);
    }

    public updateCustomerAddressesEntity(ent: Array<SalesPersonCustomerAddressDTO>): Observable<string> {
        const httpHeaders = new HttpHeaders();
        httpHeaders.set('Content-Type', 'application/json');
        return this.http.post<any>(this.API_salespersonAddressCodes_URL, ent, { headers: httpHeaders });
       }

}
